import React, {useEffect, useState} from 'react';
import { Col, Container, Row, Nav, NavItem, NavLink, TabContent, TabPane } from 'reactstrap';
import ModelProducts from '../../../../Models/Products';
import { useParams } from 'react-router-dom';
import classnames from 'classnames';
import {connect} from "react-redux";
import Panel from "../../../../shared/components/Panel";
import ProductsTable from "./components/ProductsTable";
import {showNotification} from "../../../../shared/components/Notification";
import ModalAddProduct from "./components/ModalAddProduct";
import LoadingIcon from 'mdi-react/LoadingIcon';

const ProductsWidget = ({ dispatch, loadedProducts,rtl,theme }) => {
    const { productId } = useParams();
    const [isLoaded, setIsLoaded] = useState(false);
    const vm = new ModelProducts();

    const fetchData=()=>{
        return vm.getAllProducts().then(async response => {

            if (response.data.status === 'failed') {
                alert('failed');
                return false;
            }


            setIsLoaded(true);
            return true;
        });
    };

    useEffect(() => {
        // dispatch(showVenueMenu(true));
        fetchData();
    },[]);

    return (
        <Container className="dashboard">
            <Row>
                <Panel xl={12} lg={12} md={12} title={'Featured Products'} refreshFunction={fetchData}>
                    {!isLoaded &&
                        <div className="panel__refresh"><LoadingIcon/></div>
                    }
                    {isLoaded &&
                        <ProductsTable/>
                    }

                </Panel>
            </Row>
        </Container>
    );
}

export default connect(state => ({
    rtl: state.rtl,
    theme: state.theme,
    loadedProducts:state.products.loadedProducts,
    // showVenueMenu:state.venue.showVenueMenu
}))(ProductsWidget);